// NotFoundPage.tsx

import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Link as RouterLink } from 'react-router-dom';

export const NotFoundPage: React.FC = () => {
  return (
    <Box sx={{ bgcolor: '#FAFAFB', minHeight: '100vh', display: 'flex', alignItems: 'center' }}>
      <Container
        maxWidth="sm"
        sx={{
          textAlign: 'center',
          py: 10,
        }}
      >
        <ErrorOutlineIcon sx={{ fontSize: 80, color: 'error.main', mb: 2 }} />
        <Typography variant="h4" gutterBottom>
          Seite nicht gefunden
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          Die angeforderte Seite existiert nicht oder wurde verschoben.
        </Typography>

        <Button
          variant="contained"
          color="primary"
          size="large"
          component={RouterLink}
          to="/"
        >
          Zurück zur Startseite
        </Button>
      </Container>
    </Box>
  );
};
